<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-规则-添加
    -->
    <el-dialog
    title="添加规则"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加规则</div>
      <el-form-item label="规则名称" prop="name"><el-input v-model="form.name" placeholder="请输入规则名称" class="max-w460"></el-input></el-form-item>

      <el-form-item label="类型"  prop="type" :rules="[{ required: true, message: '请选择类型' }]">
        <el-select v-model="form.type" placeholder="类型">
            <el-option label="无分类" value=""></el-option>
            <el-option v-for="(item,index) in ruleType" :key="index" :value="item.value" :label="item.label"  style="margin-bottom: 10px;">
              {{ item.label }}
            </el-option> 
          </el-select>
      </el-form-item>

      <el-form-item label="操作对象" prop="obj" :rules="[{ required: true, message: '请选择操作对象' }]">
        <el-radio-group  v-model="form.obj">

          <el-radio v-for="(item,index) in rule" :key="index" :label="item.value"  style="margin-bottom: 10px;">{{ item.label }}</el-radio> 

        </el-radio-group>
      </el-form-item>



      
      <el-form-item label="操作" prop="setting.price_type" 
      :rules="[{ required: true, message: '请选择操作' }]" >
          <el-select v-model="form.setting.price_type" placeholder="操作">
            <el-option label="请选择操作" value=""></el-option>
            <el-option v-for="(item,index) in rulePrice" :key="index" :value="item.value" :label="item.label"  style="margin-bottom: 10px;">
              {{ item.label }}
            </el-option> 
          </el-select>
      </el-form-item>

      <el-form-item label="资金" >
        <el-input v-model="form.setting.price" placeholder="发放资金(可设置为0)" style="width: 200px;"></el-input>
      </el-form-item>


      

      <el-form-item label="选择等级">
           <div>不选择 则不限制用户等级</div>
           <el-table size="small" :data="form.setting.gradeList" border>
             <el-table-column prop="name" label="等级"></el-table-column>

             <el-table-column prop="second_rebate" label="选择等级">
               <template slot-scope="scope">
                   <el-checkbox v-model="scope.row.sel_grade">选择该等级</el-checkbox> 
               </template>
             </el-table-column>
           </el-table>
          
     </el-form-item>


      <el-form-item label="备注">
        <el-input type="textarea" v-model="form.remark" placeholder="请输入备注" style="width: 500px;"></el-input>
      </el-form-item>


    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</el-dialog>
  
</template>

<script>
import RuleApi from '@/api/rule.js';

export default {
  components: {

  },
  data() {
    return {
      /*form表单数据*/
      form: {
        name: '',
  
        type: '',
        setting:{
          gradeList:[]
        },
        obj:"",//操作对象
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入规则名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      rule:[],
      ruleType:[],
      rulePrice:[]
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getGrade();
    this.getRule();
  },
  props: ["open_add"],
  methods: {
    getRule(){
      var self = this;
      RuleApi.getRule({}, true)
            .then(data => {
              self.loading = false;
              console.log(data)
              self.rule = data.data.rule;
              self.ruleType = data.data.ruleType;
              self.rulePrice = data.data.rulePrice;
            })
            .catch(error => {
              self.loading = false;
            });
    },
    getGrade() {
      let self = this;
      // 取到路由带过来的参数
      RuleApi.getGrade({},true).then(res => {
          self.form.setting.gradeList = res.data;
          self.loading = false;
        })
        .catch(error => {});
    },
     /*关闭弹窗*/
     dialogFormVisible() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          RuleApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/rule/part/add.vue